import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/ikona_vylepseni.svg")